import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockClockIcon from '@mui/icons-material/LockClock';
import { Link as RouterLink } from 'react-router-dom';

// 5 ago 2026 (Tarea #92, continuación del pedido de Augusto: "si pasan
// los 14 días, se debe de bloquear acceso a todo el aplicativo, no solo
// a la importación de páginas"): pantalla que reemplaza el contenido de
// CUALQUIER página del aplicativo (ver TrialGate en NotionLayout.js)
// cuando la prueba gratuita venció y el cliente no pagó. El backend ya
// rechaza estas mismas rutas con 402 (ver require_active_trial_or_paid
// en deps.py) -- esta pantalla es la explicación visual de por qué todo
// dejó de funcionar, con un único camino hacia adelante: Suscripción.
const TrialExpiredScreen = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 5,
          maxWidth: 480,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <LockClockIcon sx={{ fontSize: 48, color: 'warning.main', mb: 2 }} />
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Tu prueba gratuita de 14 días terminó
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Para seguir usando PCM — tus transacciones, deudas, presupuestos, informes y todo lo
          demás — activa un plan pago. Tu información sigue guardada y estará disponible apenas
          actualices tu suscripción.
        </Typography>
        <Button
          component={RouterLink}
          to="/subscription"
          variant="contained"
          size="large"
          sx={{ fontWeight: 700, px: 4 }}
        >
          Ver planes y activar
        </Button>
      </Paper>
    </Box>
  );
};

export default TrialExpiredScreen;
